import React from 'react';
import background from '../../assets/ask-atmosphere.jpg';
import ReusableAskearth from '../../components/ReusableAskearth/ReusableAskearth';

class AskAtmosphere extends React.Component {
  render () { 
   return(
  
  <ReusableAskearth             
    
        tag="ASK EARTH"
        description01="Why is rising CO2 harmful?"
        
        
        background={background}
     />
  
  );
 }
}   

export default AskAtmosphere;